import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
export function normalizePasses(passes) {
  return passes.map(function (pass) {
    if (typeof pass === 'string') {
      pass = [pass, {}];
    }

    return pass;
  });
}
export function createMultiPassRenderer(layer, passes, postProcessingPassFactory, normalPassFactory) {
  var multiPassRenderer = layer.multiPassRenderer;

  var _layer$getLayerConfig = layer.getLayerConfig(),
      enablePicking = _layer$getLayerConfig.enablePicking,
      enableTAA = _layer$getLayerConfig.enableTAA;

  if (enableTAA) {
    multiPassRenderer.add(normalPassFactory('taa'));
  } else {
    multiPassRenderer.add(normalPassFactory('render'));
  }

  normalizePasses(passes).forEach(function (pass) {
    var _pass = _slicedToArray(pass, 2),
        passName = _pass[0],
        initializationOptions = _pass[1];

    multiPassRenderer.add(postProcessingPassFactory(passName), initializationOptions);
  });
  multiPassRenderer.add(postProcessingPassFactory('copy'));
  return multiPassRenderer;
}
//# sourceMappingURL=multiPassRender.js.map